(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logos"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCarousel(wrapper) {
    var track = wrapper.querySelector('.brand-logos2__track');
    var container = wrapper.querySelector('.brand-logos2__track-container');
    var prevBtn = wrapper.querySelector('.brand-logos2__arrow--prev');
    var nextBtn = wrapper.querySelector('.brand-logos2__arrow--next');

    if (!track || !container) return;

    var rafId = null;
    var currentX = 0;
    var itemWidth = 0;
    var totalWidth = 0;
    var isPaused = false;
    var lastTime = null;

    function getGap() {
      return parseInt(wrapper.getAttribute('data-gap')) || 16;
    }

    function getAutoplay() {
      return wrapper.getAttribute('data-autoplay') === 'true';
    }

    function getSpeedSetting() {
      var s = parseFloat(wrapper.getAttribute('data-speed')) || 2;
      return itemWidth > 0 ? (itemWidth + getGap()) / s : 80;
    }

    function rebuild() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
      lastTime = null;

      track.querySelectorAll('.brand-logos2__clone').forEach(function(el) { el.remove(); });

      var originals = Array.from(track.querySelectorAll('.brand-logos2__slide:not(.brand-logos2__clone)'));
      var total = originals.length;
      if (total === 0) return;

      var gap = getGap();
      var sampleBox = originals[0].querySelector('.brand-logos2__box');
      itemWidth = sampleBox ? sampleBox.offsetWidth : 120;

      originals.forEach(function(slide) {
        slide.style.width = itemWidth + 'px';
        slide.style.minWidth = itemWidth + 'px';
      });

      for (var i = 0; i < 3; i++) {
        originals.forEach(function(slide) {
          var c = slide.cloneNode(true);
          c.classList.add('brand-logos2__clone');
          c.setAttribute('aria-hidden', 'true');
          c.style.width = itemWidth + 'px';
          c.style.minWidth = itemWidth + 'px';
          track.appendChild(c);
        });
      }

      track.style.gap = gap + 'px';
      track.style.transition = 'none';
      track.style.transform = 'translateX(0)';

      totalWidth = (itemWidth + gap) * total;
      currentX = 0;

      if (getAutoplay()) startContinuousScroll();
    }

    function startContinuousScroll() {
      if (rafId) cancelAnimationFrame(rafId);
      lastTime = null;

      function step(timestamp) {
        if (!lastTime) lastTime = timestamp;
        var delta = timestamp - lastTime;
        lastTime = timestamp;

        if (!isPaused) {
          var pps = getSpeedSetting();
          currentX += (pps * delta) / 1000;
          if (currentX >= totalWidth) currentX -= totalWidth;
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + currentX + 'px)';
        }

        rafId = requestAnimationFrame(step);
      }

      rafId = requestAnimationFrame(step);
    }

    function stopScroll() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
      lastTime = null;
    }

    container.addEventListener('mouseenter', function() { isPaused = true; });
    container.addEventListener('mouseleave', function() { isPaused = false; });

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        currentX = Math.max(0, currentX - (itemWidth + getGap()));
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        currentX += (itemWidth + getGap());
        if (currentX >= totalWidth) currentX -= totalWidth;
      });
    }

    var observer = new MutationObserver(function() {
      stopScroll();
      rebuild();
    });
    observer.observe(wrapper, {
      attributes: true,
      attributeFilter: ['data-autoplay', 'data-speed', 'data-gap']
    });

    document.addEventListener('shopify:section:load', function() {
      stopScroll();
      rebuild();
    });

    rebuild();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        stopScroll();
        rebuild();
      }, 150);
    });
  }

  function init() {
    document.querySelectorAll('.brand-logos2__wrapper').forEach(function(wrapper) {
      initCarousel(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
